import React from "react";
import { useTranslation } from "react-i18next";
import { CalendarClock, Clock, Mail, MessageSquare } from "lucide-react";
import settings from "../../data/settings.json";

// Public booking page (Google Calendar appointment schedule) from settings.json;
// REACT_APP_BOOKING_URL overrides it, e.g. for a test schedule.
const BOOKING_URL = process.env.REACT_APP_BOOKING_URL || settings.booking?.url;
// Google's booking page draws its own header (name, logo, title, duration) that repeats ours;
// the frame starts this many pixels below its top to hide it.
const GOOGLE_HEADER = BOOKING_URL?.includes("calendar.google.com") ? 150 : 0;

const BookCall = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex items-start gap-3 mb-5">
        <span className="w-10 h-10 rounded-xl bg-rose-soft text-rose flex items-center justify-center flex-shrink-0">
          <CalendarClock size={20} />
        </span>
        <div>
          <h2 className="text-lg font-extrabold text-ink">{t("contact.call.title")}</h2>
          <p className="text-sm text-zinc-500 leading-relaxed mt-0.5">{t("contact.call.desc")}</p>
        </div>
      </div>

      <ul className="flex flex-wrap gap-x-6 gap-y-2 mb-5 text-sm text-zinc-600">
        <li className="flex items-center gap-2">
          <Clock size={15} className="text-rose" /> {t("contact.call.hours")}
        </li>
        <li className="flex items-center gap-2">
          <MessageSquare size={15} className="text-rose" /> {t("contact.call.note")}
        </li>
      </ul>

      {BOOKING_URL ? (
        // Tall enough that the booking page doesn't need its own scrollbar on desktop.
        <div className="relative overflow-hidden rounded-2xl border border-zinc-200 bg-white h-[640px] sm:h-[720px]">
          <iframe
            src={BOOKING_URL}
            title={t("contact.call.title")}
            loading="lazy"
            className="absolute inset-x-0 w-full border-0"
            style={{ top: -GOOGLE_HEADER, height: `calc(100% + ${GOOGLE_HEADER}px)` }}
          />
        </div>
      ) : (
        <div className="rounded-2xl border border-dashed border-zinc-300 p-8 text-center">
          <p className="text-zinc-500 leading-relaxed max-w-sm mx-auto">{t("contact.call.unavailable")}</p>
          <a
            href={`mailto:${settings.company.email}?subject=${encodeURIComponent(t("contact.call.emailSubject"))}`}
            className="btn-rose mt-6"
          >
            <Mail size={16} /> {t("contact.call.emailCta")}
          </a>
        </div>
      )}
    </div>
  );
};

export default BookCall;
